import React from 'react';
import { FieldValues } from 'react-hook-form';
import type { TFunction } from 'i18next';
import { WallDiagonal, WallHorizontal } from 'assets';
import { TInputParams, TLocaleText } from 'entries/common/widgets/context';
import { LayingType, LayingTypeCalculationPercentage } from 'pages/common/components/LayingTypeField/const';
import { LocalizedTextLanguages } from 'pages/common/consts/frontend-configuration';
import { ParametersEnum } from '../../types';

export const checkIsSumWrong = (data: FieldValues) => {
  if (!data.length) {
    return undefined;
  }
  const length = Number(data.length);
  const width = Number(data.width);
  const height = Number(data.height);
  const doorsResult = Number(data.doors) * 1.4;
  const windowsResult = data.windows ? Number(data.windows) * 2.73 : 0;
  const sum = (length + width) * 2 * height - doorsResult - windowsResult;

  return sum <= 0;
};

export const setIsAreaEnabledHandler = (
  filteredInputParams: TInputParams,
  setIsAreaEnabled: (valOrUpdater: boolean | ((currVal: boolean) => boolean)) => void
) => {
  if (filteredInputParams.includes(ParametersEnum.area) && filteredInputParams.length === 1) {
    setIsAreaEnabled(true);
  }
};

export const setShowWarningBarHandler = (
  hasNegativeParams: boolean | undefined,
  setShowWarningBar: (valOrUpdater: boolean | ((currVal: boolean) => boolean)) => void
) => {
  if (hasNegativeParams) {
    setShowWarningBar(true);
  } else {
    setShowWarningBar(false);
  }
};

export const getRoomParametersAreaText = (areaEnabledState: boolean): string =>
  areaEnabledState ? 'Указать количество' : 'Указать размеры';

export const getRoomParamsQuantity = (filteredInputParams: TInputParams) =>
  filteredInputParams.length > 3
    ? [
        { inputParameters: filteredInputParams.slice(0, 2), key: 'large_start' },
        { inputParameters: filteredInputParams.slice(2), key: 'large_end' },
      ]
    : [{ inputParameters: filteredInputParams, key: 'mobile' }];

export const getTabListLabels = (translate: TFunction) => [
  {
    label: translate('tabListLabels.lengthWidth'),
    id: 'length',
  },
  {
    label: translate('tabListLabels.area'),
    id: 'area',
  },
];

export const getDimensionsLabels = (translate: TFunction) => ({
  length: translate('calculator.dimensions.fieldLabels.length'),
  width: translate('calculator.dimensions.fieldLabels.width'),
  area: translate('calculator.dimensions.fieldLabels.area'),
  layerThickness: translate('calculator.dimensions.fieldLabels.layerThickness'),
  height: translate('calculator.dimensions.fieldLabels.height'),
  doors: translate('calculator.dimensions.fieldLabels.doors'),
  windows: translate('calculator.dimensions.fieldLabels.windows'),
});

export const getLayingTypes = (translate: TFunction) => [
  {
    name: LayingType.horizontal,
    label: translate('calculator.dimensions.layingType.labels.horizontal'),
    calculationPercentage: `${LayingTypeCalculationPercentage[LayingType.horizontal]} ${translate(
      'calculator.dimensions.layingType.materialStock'
    )}`,
    getIcon: () => <WallHorizontal />,
  },
  {
    name: LayingType.diagonal,
    label: translate('calculator.dimensions.layingType.labels.diagonal'),
    calculationPercentage: `${LayingTypeCalculationPercentage[LayingType.diagonal]} ${translate(
      'calculator.dimensions.layingType.materialStock'
    )}`,
    getIcon: () => <WallDiagonal />,
  },
];

export const getLabelText = (label: TLocaleText[]): string =>
  label.find((lbl: { language: string; text: string }) => lbl.language === LocalizedTextLanguages.RU)
    ?.text ?? '';
